import paymentMethod from '@drivesally/sally-fn/lib/transaction/libs/usedPaymentMethod.lib.transaction';

export default ({transaction = {}} = {}) => paymentMethod(transaction);
